export default {"src":"/_next/static/media/working-empty.46cee0e3.svg","height":25,"width":25};